import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import invitationReducer from './slices/invitationSlice';
import uiReducer from './slices/uiSlice';
import availabilityReducer from './slices/availabilitySlice';
import bookingReducer from './slices/bookingSlice';
import userDashboardReducer from './slices/userDashboardSlice';
import astrologerDashboardReducer from './slices/astrologerDashboardSlice';
import walletReducer from './slices/walletSlice';
import earningsReducer from './slices/earningsSlice';
import ledgerReducer from './slices/ledgerSlice';
import notificationReducer from './slices/notificationSlice';
import broadcastReducer from './slices/broadcastSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    invitations: invitationReducer,
    ui: uiReducer,
    availability: availabilityReducer,
    booking: bookingReducer,
    userDashboard: userDashboardReducer,
    astrologerDashboard: astrologerDashboardReducer,
    wallet: walletReducer,
    earnings: earningsReducer,
    ledger: ledgerReducer,
    notifications: notificationReducer,
    broadcast: broadcastReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export default store;
